














import { Component, Vue } from 'vue-property-decorator'
import Breadcrumb from '@/components/Breadcrumb/index.vue'

@Component({
  name: 'AppMain',
  components: {
    Breadcrumb
  }
})
export default class extends Vue {}
